import { TProductSocialMedia } from './Product'

export enum CommunityMemberStatus {
  PendingAdd = 0,
  Active = 1,
  PendingRemove = 2,
  Removed = 3,
  Failed = 4,
}

export type TCommunityMember = {
  id: string
  customerId: string
  customerName: string
  customerEmail: string
  orderId: string
  orderCodeId: string
  status: CommunityMemberStatus
  platformType: TProductSocialMedia
  hasJoinedCommunity: boolean
  isInviteLinkExpired: boolean
  isInviteLinkRevoked: boolean
  inviteLinkExpiresAt: string | null
  inviteLink: string | null
  createdDate: string
  customerPhone: string | null
}

export type TCommunityMemberPagination = {
  items: TCommunityMember[]
  page: number
  total: number
  rowsPerPage: number
  totalPages: number
  hasBackPage: boolean
  hasNextPage: boolean
  isLastPage: boolean
}
